import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store/root-reducer';

const selectResetPassword = (state: RootState) => state.resetPassword;

export const selectDraft = (state: RootState) => selectResetPassword(state).draft;
export const selectStatus = (state: RootState) => selectResetPassword(state).status;
export const selectError = (state: RootState) => selectResetPassword(state).error;
export const selectValidationErrors = (state: RootState) =>
  selectResetPassword(state).validationErrors;
export const selectIsSubmitting = (state: RootState) =>
  selectResetPassword(state).status === 'submitting';
/** Has the password been reset? Drives the success view + redirect to login. */
export const selectHasSucceeded = (state: RootState) =>
  selectResetPassword(state).status === 'succeeded';

/**
 * Derived: can the form be submitted? Deliberately non-emptiness only (the
 * original page's `disabled={!password || !confirmPassword}`); the min-length
 * and match rules fire at submit time in the saga, like the original early
 * returns. Memoised on the draft reference.
 */
export const selectCanSubmit = createSelector(
  selectDraft,
  (draft) => draft.password !== '' && draft.confirmPassword !== '',
);
